(function ($) {
    var currentProductPage = 1;
    var productAjax = null;
    var ajaxTimeout = null;

    var initializeSingleProductButton = function () {
        let queue = JSON.parse(localStorage.getItem("productQueue")) || [];
        let productId = $(".js-add-to-queue").data("id");

        if (queue.includes(productId)) {
            $(".js-add-to-queue .js-text").text("Added");
        }
    };

    var hideFilterDropdown = function () {
        var $dropdown = $(".js-dropdown-filter-product");
        $dropdown.removeClass("show");
        $dropdown.find(".dropdown-menu").removeClass("show");
        $dropdown.find('[data-toggle="dropdown"]').attr("aria-expanded", false);
    };

    function debounce(func, wait) {
        let timeout;
        return function () {
            const context = this,
                args = arguments;
            clearTimeout(timeout);
            timeout = setTimeout(() => func.apply(context, args), wait);
        };
    }

    var modifySearchTerm = function (searchTerm) {
        // Replace any occurrence of "as" followed by four digits with "as-" followed by those digits
        return searchTerm.replace(/\bas(\d{4})\b/gi, "as-$1");
    };

    var loadProductRaw = function () {
        var template = $("#js-product-item").html();
        var $loader = $(".js-product-loader");
        var $list = $(".js-product-list");
        var $loadMore = $(".js-product-next-page");

        Mustache.parse(template);

        var data = {
            page: currentProductPage,
            nonce: rissb_var.nonces.get_products
        };

        if (window.matchMedia("(max-width: 768px)").matches) {
            data.filters = $(
                ".filter-mobile .js-product-filters :input"
            ).serialize();
        } else {
            data.filters = $(
                ".filter-desktop .js-product-filters :input"
            ).serialize();
        }

        if (data.page == 1) {
            $loader.removeClass("d-none");
            $list.empty();
        }

        if (productAjax) {
            productAjax.abort();
        }

        productAjax = $.get("/api/products", data, function (res) {
            if (Array.isArray(res.data.data)) {
                var products = res.data.data;
                var maxLength = 200;

                products.forEach(function (product) {
                    var excerpt = product.excerpt;
                    if (excerpt.length > maxLength) {
                        product.excerpt =
                            excerpt.substring(0, maxLength) + "...";
                    }

                    product.isTypestandard = product.type.id === 5; // Standard
                    product.isTypeahnr = product.type.id === 113; // AHNR
                    product.isTypecop = product.type.id === 9; // Code of Practice
                    product.isTypeguideline = product.type.id === 8; // Guideline
                    product.isTyperap = product.type.id === 6;
                    product.isTypeother = product.type.id === 7;
                    var createdDate = new Date(product.date);
                    var cutoffDate = new Date('2025-12-19T00:00:00'); // Compare against midnight 16 Dec 2025
                    product.isAfterCutoff = createdDate > cutoffDate;
                });

                var rendered = Mustache.render(template, res.data);

                $loader.addClass("d-none");

                if (data.page == 1) {
                    $list.html(rendered);
                } else {
                    $list.append(rendered);
                }

                // Initialize button state based on local storage
                initializeQueueButtons();

                $(rendered).imagesLoaded(function () {
                    $.fn.matchHeight._apply('[data-mh="product-thumb"]');
                });

                $loadMore
                    .closest("div")
                    .toggleClass(
                        "d-none",
                        res.data.pagination.total <= res.data.pagination.current
                    );
            } else {
                console.error("Response data is not an array:", res.data);
            }
        }).always(function () {
            $loadMore.text($loadMore.data("text-original"));
        });
    };

    var loadProduct = debounce(loadProductRaw, 300);

    var initializeQueueButtons = function () {
        let queue = JSON.parse(localStorage.getItem("productQueue")) || [];
        console.log("Initializing buttons. Current queue:", queue);

        // Reset all buttons to "Add to Queue"
        $(".js-add-to-queue").each(function () {
            var $button = $(this);
            $button.find(".js-text").text("Add to Queue");
        });

        // Update buttons for products in the queue
        queue.forEach(function (id) {
            var $button = $('.js-add-to-queue[data-id="' + id + '"]');
            if ($button.length) {
                $button.find(".js-text").text($button.data("text-original"));
                console.log("Updated button text for product ID:", id);
            }
        });
    };

    var resizeProductTable = function () {
        if (!$("body").hasClass("single-product")) {
            return;
        }

        var tableWidth =
            $(".product-details").outerWidth() -
            $(".product-meta").outerWidth() -
            34; // magic number
        $(".product-details")
            .find(".table-product")
            .width(tableWidth);
    };

    $(window).on("load resize", resizeProductTable);

    var clearFilters = function () {
        $('.js-product-filters input[type="checkbox"]')
            .prop("checked", false)
            .change();
        $('[name="orderby"]').val("last_updated");
        $('[name="order"]').val("desc");
        $(".js-order-type").text("Date - Last Updated");
    };

    $(document).ready(function () {
        if ($('body').hasClass('post-type-archive-product')) {
            initializeSingleProductButton();

            $(".js-product-search").on("keypress", function (event) {
                if (event.which === 13) {
                    // Modify search term before triggering search
                    var $searchInput = $(this);
                    var modifiedSearchTerm = modifySearchTerm($searchInput.val());
                    $searchInput.val(modifiedSearchTerm);

                    $(".js-product-search-btn").click();
                }
            });

            $(".js-product-filters")
                .find(
                    'input[name="product_types[]"], input[name="product_categories[]"]'
                )
                .on("change", function () {
                    currentProductPage = 1;
                    loadProduct();
                });

            $(".js-dropdown-filter-product").on("show.bs.dropdown", function (e) {
                $(this)
                    .closest(".btn-group-dropdown")
                    .find(".dropdown-order")
                    .addClass("show");
            });

            $(".js-dropdown-filter-product").on("hide.bs.dropdown", function () {
                $(this)
                    .closest(".btn-group-dropdown")
                    .find(".dropdown-order")
                    .removeClass("show");
            });

            if ($(".js-product-list").length) {
                currentProductPage = 1;
                loadProduct();
            }

            $(".js-clear-dropdown-filter").on("click", function () {
                clearFilters();
                // loadProduct();
            });

            var $filter = $(".js-dropdown-filter-product");

            $(".js-product-filters")
                .find('input[name="search_in[]"], input[name="product_status[]"]')
                .on("change", function () {
                    var $this = $(this);
                    currentProductPage = 1;

                    RISSB.fn.updateQSParams(
                        "search_in[]",
                        $this
                            .closest(".js-product-filters")
                            .find('input[name="search_in[]"]:checked')
                            .map(function () {
                                return $(this).val();
                            })
                            .get(),
                        true
                    );

                    RISSB.fn.updateQSParams(
                        "product_status[]",
                        $this
                            .closest(".js-product-filters")
                            .find('input[name="product_status[]"]:checked')
                            .map(function () {
                                return $(this).val();
                            })
                            .get(),
                        true
                    );

                    loadProduct();
                });

            $(".js-product-list").on("click", '[data-toggle="modal"]', function (e) {
                e.preventDefault();
                $($(this).data("target")).modal("show");
            });

            RISSB.fn.clearDropdownFilter(function () {
                currentProductPage = 1;
                loadProduct();
            });

            $(".js-product-filters")
                .find(".js-product-search-btn")
                .on("click", function (e) {
                    var keyword;
                    currentProductPage = 1;

                    if (window.matchMedia("(max-width: 768px)").matches) {
                        keyword = $.trim(
                            $(".filter-mobile .js-product-filters")
                                .find(".js-product-search")
                                .val()
                        );
                    } else {
                        keyword = $.trim(
                            $(".filter-desktop .js-product-filters")
                                .find(".js-product-search")
                                .val()
                        );
                    }

                    // Modify the keyword before proceeding
                    keyword = modifySearchTerm(keyword);

                    if (keyword === "") {
                        $(
                            '.dropdown-order .dropdown-item[data-orderby="last_updated"]'
                        ).click();
                    } else {
                        $(
                            '.dropdown-order .dropdown-item[data-orderby="relevance"]'
                        ).click();
                    }

                    loadProduct();
                });

            $(".js-update-filter").on("click", function () {
                var $this = $(this);
                currentProductPage = 1;

                RISSB.fn.updateQSParams(
                    "product_types[]",
                    $this
                        .closest(".form-group")
                        .find('input[name="product_types[]"]:checked')
                        .map(function () {
                            return $(this).val();
                        })
                        .get(),
                    true
                );

                RISSB.fn.updateQSParams(
                    "product_categories[]",
                    $this
                        .closest(".form-group")
                        .find('input[name="product_categories[]"]:checked')
                        .map(function () {
                            return $(this).val();
                        })
                        .get(),
                    true
                );

                hideFilterDropdown();
                loadProduct();
            });

            $filter
                .find('input[type="checkbox"]')
                .on("change", function () {
                    $filter.each(function () {
                        var $currentFilter = $(this);
                        var checked = $currentFilter.find(
                            'input[type="checkbox"]:checked'
                        ).length;
                        $currentFilter
                            .find(".js-filter-count")
                            .text(checked > 0 ? " (" + checked + ")" : "");
                    });
                })
                .change();

            $(".dropdown-order").on("click", ".dropdown-item", function (e) {
                e.preventDefault();

                var $this = $(this);
                currentProductPage = 1;

                $('[name="orderby"]').val($this.data("orderby"));
                $('[name="order"]').val($this.data("order"));
                $(".js-order-type").text($this.text());

                $(".dropdown-order .dropdown-item").removeClass("active");
                $this.addClass("active");

                clearTimeout(ajaxTimeout);
                ajaxTimeout = setTimeout(loadProduct, 500);
            });

            $(".js-clear-dropdown-filter").on("click", function () {
                clearFilters();
                // loadProduct();

                $(".dropdown-order .dropdown-item").removeClass("active");
            });

            $(document).on("click", function (event) {
                if ($(event.target).closest(".dropdown-order").length) {
                    event.stopImmediatePropagation();
                }
            });

            $(".js-product-next-page").on("click", function (e) {
                e.preventDefault();

                var $this = $(this);
                currentProductPage = currentProductPage + 1;

                $this.html(
                    '<i class="fas fa-spinner fa-spin fa-fw"></i> ' +
                    $this.data("text-progress")
                );
                loadProduct();
            });

            $(".js-product-list").on("click", ".js-filter-type", function (e) {
                e.preventDefault();

                var $this = $(this);

                $(".js-dropdown-filter-product")
                    .find('[type="checkbox"][name="product_types[]"]')
                    .prop("checked", false);
                $(".js-dropdown-filter-product")
                    .find(
                        '[type="checkbox"][name="product_types[]"][value="' +
                        $this.data("id") +
                        '"]'
                    )
                    .prop("checked", true)
                    .change();

                RISSB.fn.updateQSParams("product_types[]", $this.data("id"));

                currentProductPage = 1;

                loadProduct();
            });

            $(document).on("click", ".js-add-to-queue", function (e) {
                e.preventDefault();

                var $this = $(this);
                $this.find(".js-text").text($this.data("text-progress"));

                $.post(
                    "/api/products/queue/add",
                    {
                        id: $this.data("id"),
                        nonce: rissb_var.nonces.add_product_to_queue
                    },
                    function (res) {
                        RISSB.fn.loadQueue();

                        let queue =
                            JSON.parse(localStorage.getItem("productQueue")) || [];
                        if (!queue.includes($this.data("id"))) {
                            queue.push($this.data("id"));
                            localStorage.setItem(
                                "productQueue",
                                JSON.stringify(queue)
                            );
                        }
                        // Log the updated local storage
                        console.log("Product added to queue:", queue);
                        RISSB.fn.loadQueue(true);
                        $(document).trigger("rissb:queue:ids", [queue])
                    }
                ).always(function () {
                    $this.find(".js-text").text($this.data("text-original"));
                });
            });

            $(".js-list-products-queue").on(
                "click",
                ".js-remove-product-from-queue",
                function (e) {
                    e.preventDefault();

                    var $this = $(this);

                    $.post(
                        "/api/products/queue/remove",
                        {
                            id: $this.data("id"),
                            nonce: rissb_var.nonces.remove_product_from_queue
                        },
                        function(res) {
                            RISSB.fn.loadQueue(true);

                            let queue =
                                JSON.parse(localStorage.getItem("productQueue")) ||
                                [];
                            let index = queue.indexOf($this.data("id"));
                            if (index > -1) {
                                queue.splice(index, 1);
                                localStorage.setItem(
                                    "productQueue",
                                    JSON.stringify(queue)
                                );
                            }

                            if (queue.length === 0) {
                                localStorage.removeItem("productQueue");
                            }

                            // Update button text back to "Add to Queue"
                            var $button = $(
                                '.js-add-to-queue[data-id="' +
                                $this.data("id") +
                                '"]'
                            );
                            if ($button.length) {
                                $button.find(".js-text").text("Add to Queue");
                            }

                            initializeQueueButtons();
                            // Log the updated local storage
                            console.log("Product removed from queue:", queue);

                            RISSB.fn.loadQueue(true);
                            $(document).trigger("rissb:queue:ids", [queue]);
                        }
                    );
                }
            );

            $(document).on("click", ".js-clear-queue", function (e) {
                e.preventDefault();

                // Clear local storage
                localStorage.removeItem("productQueue");

                // Update button states
                initializeQueueButtons();

                // Clear via API and refresh UI
                $.post(
                    "/api/products/queue/clear",
                    {
                        nonce: rissb_var.nonces.clear_queue
                    },
                    function (res) {
                        RISSB.fn.loadQueue(true);
                        $(document).trigger("rissb:queue:ids", [[]]); // tell UI queue is empty
                    }
                );
            });


            $(document).on("click", ".js-quick-preview", function (e) {
                e.preventDefault();
                $("#modal-product-quick-review").modal("show", $(this));
            });

            $(document).on("show.bs.modal", "#modal-product-quick-review", function (
                e
            ) {
                var $this = $(this);
                var productId = $(e.relatedTarget).data("id");
                var template = $("#js-product-modal-item").html();
                var $loader = $this.find(".loader");
                var $nextProduct = $(".product-" + productId).next(".media");
                var $prevProduct = $(".product-" + productId).prev(".media");

                RISSB.fn.populateProductQuickPreviewModal(productId, ".media");

                $(document).on("click", '[data-toggle="modal"]', function (e) {
                    $("#modal-product-quick-review").modal("hide");
                });

                $(document).on("click", ".js-modal-previous-product", function (e) {
                    e.preventDefault();
                    RISSB.fn.populateProductQuickPreviewModal(
                        $prevProduct.find(".js-quick-preview").data("id"),
                        ".media"
                    );
                });

                $(document).on("click", ".js-modal-next-product", function (e) {
                    e.preventDefault();
                    RISSB.fn.populateProductQuickPreviewModal(
                        $nextProduct.find(".js-quick-preview").data("id"),
                        ".media"
                    );
                });
            });
        }
    });
})(jQuery);
